import { useTranslation } from "react-i18next";

const LegalAgreementsContact = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-lg border border-indigo-200 p-8 text-center">
      <h3 className="text-xl font-semibold text-indigo-900 mb-4">
        {t("legalAgreements_contactTitle")}
      </h3>
      <p className="text-gray-700 mb-4">{t("legalAgreements_contactText")}</p>
      <div className="space-y-2">
        <p className="text-darkBlue">
          <a
            href="mailto:hola@jandipr.com"
            className="hover:text-indigo-800 transition-colors"
          >
            hola@jandipr.com
          </a>
        </p>
        <p className="text-darkBlue">{t("legalAgreements_contactAddress")}</p>
      </div>
    </div>
  );
};

export default LegalAgreementsContact;
